/*
 * Created with JetBrains WebStorm.
 * User: mslobozeanu
 * Date: 15/06/2015
 */

/** @namespace TS */
/** @namespace TS.domain */

TS.ns('TS.domain.properties');

(function () {
    'use strict';

    var baseMappings = TS.domain.properties.DomainProperty.prototype.mapping;

    // add sender to eventArgs and ensure the return value is not null
    function addSender(sender, e) {
        e = e || {};
        e.sender = sender;
        return e;
    }

    /**
     * @class TS.domain.properties.BindingListProperty
     * @ignore
     */
    TS.domain.properties.BindingListProperty = new Class(
        /** @lends TS.domain.properties.BindingListProperty# */
        {
            Extends: TS.domain.properties.DomainProperty,

            Identifier: 'UID',
            _SelectedItemId: null,
            PageSize: null,

            observables: {
                SelectedItemId: null,
                SelectedItem: null,
                AllowAdd: true,
                AllowEdit: true,
                AllowDelete: true,
                SelectionMode: "Simple"
            },

            mapping: $.extend(baseMappings, {
                ignore: baseMappings.ignore.concat(['Fields', 'Commands']),
                copy: baseMappings.copy.concat(['Identifier', 'StartIndex', 'SelectionMode', 'PageSize', 'propertyType', '__ReadOnlyDataContext']),
                suppress: baseMappings.suppress.concat(['Identifier', 'StartIndex', 'AllowAdd', 'AllowEdit', 'AllowDelete', 'SelectionMode', 'PageSize', 'selection', 'propertyType', '__ReadOnlyDataContext'])
            }),

            defaults: {
                Identifier: 'UID'
            },


            /**
             * @member {Array<TS.domain.properties.ListField>}
             * @memberof TS.domain.properties.BindingListProperty
             * @instance
             */
            Fields: [],
            Filters: [],

            initialize: function (domain, config) {
                var me = this;

                me.parent(domain, config);
                me.ReadOnly = ko.observable(false);
                if (config) {
                    me.createCommands(config.Commands, true);
                    me.createFields(config.Fields, true);
                }
            },

            //region ListSource

            ListSource: function () {
                var me = this;
                if (!this._ListSource) {
                    this._ListSource = ts.getPropertyValue(me.Domain(), me.EditMember(), true);
                }
                return this._ListSource || ko.observableArray([]);
            },

            onValueChanged: function (raise) {
                var me = this;

                delete me._ListSource;
                if (raise !== false) {
                    me.fireEvent('dataChanged', {sender: me});
                }
                me._SelectedItemId && me.SelectedItemId(me._SelectedItemId);
                me.updateSelectedItem();
                me.invalidateCommands();
            },

            //endregion

            //region (un)hookDomain

            hookDomain: function () {
                var me = this,
                    domain = me.Domain();

                me.parent();
            },

            unhookDomain: function () {
                var me = this;
                me.parent();
            },

            //endregion

            //region Fields

            createFields: function (config) {
                var me = this,
                    fields = [];

                $.each(config, function (key, field) {
                    fields.push(me.createField(field));
                });

                fields.getPropertyValue = function (property) {
                    var parts = (property || '').split('.'),
                        field = me.getFieldByName(parts[0]);
                    if (parts.length > 1)
                        return ts.getPropertyValue(field, parts.slice(1).join('.'));
                    return field;
                };

                fields.setPropertyValue = function (property, value) {
                    var parts = (property || '').split('.'),
                        field = me.getFieldByName(parts[0]);
                    if (parts.length > 1)
                        return ts.setPropertyValue(field, parts.slice(1).join('.'), value);
                };

                me.Fields = ko.observableArray(fields);
            },

            createField: function (config) {
                var me = this,
                    field = new TS.domain.properties.ListField.create(me, config);

                field.__server__ = true;
                return field;
            },

            updateFields: function (config) {
                var me = this,
                    fieldsChanged = false,
                    newFields = [],
                    oldFields = me.Fields(),
                    findField = function (name) {
                        var result;
                        $.each(oldFields, function (index, value) {
                            if (value.Name === name) {
                                result = value;
                                return false;
                            }
                        });
                        return result;
                    };
                newFields.getPropertyValue = oldFields.getPropertyValue;
                newFields.setPropertyValue = oldFields.setPropertyValue;
                $.each(oldFields, function (name, value) {
                    value.__server__ && (value.disposable = true);
                });
                $.each(config, function (index, value) {
                    var field = findField(value.Name);
                    if (!field) {
                        field = me.createField(value);
                        fieldsChanged = true;
                    } else {
                        delete field.disposable;
                        field._setData && field._setData(value);
                    }
                    newFields.push(field);
                });
                $.each(oldFields, function (name, value) {
                    if (value.disposable === true) {
                        value.dispose();
                        fieldsChanged = true;
                    }
                });
                me.Fields(newFields);
                return fieldsChanged;
            },

            getFieldByName: function (fieldName) {
                var me = this,
                    field = null;

                $.each(me.Fields(), function (key, fld) {
                    if (fld.Name == fieldName) {
                        field = fld;
                        return false;
                    }
                });

                return field;
            },

            getFieldByDataField: function (dataField) {
                var me = this,
                    field = null;

                $.each(me.Fields(), function (key, fld) {
                    if (fld.PropertyName() == dataField) {
                        field = fld;
                        return false;
                    }
                });

                return field;
            },

            //endregion

            //region Filters

            OnFiltersChanged: function (raise) {
                var me = this;

                if (raise !== false) {
                    me.fireEvent('filterChanged', {sender: me});
                }
            },

            //endregion

            //region Commands

            createCommands: function (config, server) {
                var me = this,
                    defaultCommands = {},
                    defaultCommand = function (code) {
                        return {
                            __default__: true,
                            Code: code,
                            Text: TS.cultures.current.common[code],
                            IconCode: TS.UI.defaultIcons[code],
                        };
                    },
                    commands = [];

                $.each(['Add', 'Delete'], function (index, code) {
                    defaultCommands[code] = commands.push(defaultCommand(code)) - 1;
                });
                if ($.isArray(config)) {
                    $.each(config, function (index, commandConfig) {
                        var commandIndex = defaultCommands[commandConfig.Code];
                        if (typeof commandIndex !== 'undefined') {
                            commandConfig.__server__ = server;
                            commands.splice(commandIndex, 1, commandConfig);
                        } else {
                            commands.push(commandConfig);
                        }
                    });
                }
                commands = ko.utils.arrayMap(commands.slice(0), function (commandConfig) {
                    var command = me.createCommand(commandConfig);
                    command.autoCreated = true;
                    return command;
                });
                me.Commands = ko.observableArray(commands);
            },


            createCommand: function (config) {
                var me = this,
                    domain = me.Domain(),
                    cmd = new TS.domain.Command(config, me),
                    strings = TS.cultures.current,
                    icons = TS.UI.defaultIcons;

                function listSourceAvalable() {
                    var listSource = me.ListSource();
                    listSource = me._ListSource; // the real list source
                    return !!(listSource && listSource() != null && listSource() != undefined);
                }

                switch (config.Code) {
                    case 'Add':
                        cmd.Text(strings.common['Add']);
                        cmd.IconCode(icons['Add']);

                        cmd.__default__ && (cmd.handler = me.addRecord);
                        cmd.__refresher__ = new ko.observable(true);
                        cmd.InternalEnabled = ko.computed(function () {
                            return cmd.__refresher__() && me.AllowAdd() && cmd.Enabled() && listSourceAvalable();
                        });
                        cmd.InternalVisible = ko.computed(function () {
                            return cmd.__refresher__() && me.AllowAdd() && cmd.Visible() && !me.ReadOnly();
                        });
                        break;
                    case 'Edit':
                        cmd.InternalEnabled = ko.computed(function () {
                            return me.AllowEdit() && cmd.Enabled() && me.SelectedItem() !== null;
                        });
                        cmd.InternalVisible = ko.computed(function () {
                            return me.AllowEdit() && cmd.Visible() && !me.ReadOnly();
                        });
                        break;
                    case 'Delete':
                        cmd.Text(strings.common['Delete']);
                        cmd.IconCode(icons['Delete']);

                        cmd.__default__ && (cmd.handler = me.deleteRecord);
                        cmd.InternalEnabled = ko.computed(function () {
                            return me.AllowDelete() && cmd.Enabled() && me.SelectedItem() !== null;
                        });
                        cmd.InternalVisible = ko.computed(function () {
                            return me.AllowDelete() && cmd.Visible() && !me.ReadOnly();
                        });
                        break;
                }
                return cmd;
            },

            updateCommands: function (config) {
                return false;
            },

            hasCommands: function () {
                return true;
            },

            getCommand: function (cmdCode) {
                var me = this,
                    ret = null;

                $.each(me.Commands(), function (idx, cmd) {
                    if (ko.valueOf(cmd.Code) == cmdCode) {
                        ret = cmd;
                        return false; //break loop
                    }
                });

                return ret;
            },

            invalidateCommands: function () {
                var me = this;
                $.each(me.Commands(), function (index, item) {
                    item.__refresher__ && item.__refresher__.notifySubscribers();
                });
            },

            //endregion

            //region Fields

            //endregion

            //region (get)setData

            _getData: function () {
                var me = this,
                    result = me.parent();
                result.SelectedItemId = me._SelectedItemId;
                return result;
            },

            _setData: function (data) {
                var me = this,
                    invalidate = false;

                me.parent(data);
                invalidate = me.updateFields(data.Fields) || invalidate;
                invalidate = me.updateCommands(data.Commands) || invalidate;
                (me._SelectedItemId !== me.SelectedItemId()) && me.onPropertyChanged('SelectedItemId');

                invalidate && me.invalidate();
            },

            //endregion

            invalidate: function () {
                var me = this;
                me.fireEvent('invalidate', {sender: me})
            },

            /**
             * Gets the record with the specified UID.
             * @param uid {Number}
             * @returns {Object} The record with the passed UID. Returns null if not found.
             */
            findByUid: function (uid) {
                var me = this,
                    listSource = ko.valueOf(me.ListSource()),
                    record = null;

                $.each(listSource, function (idx, item) {
                    if (ko.valueOf(item[me.Identifier]) == uid) {
                        record = item;
                        return false;
                    }
                });

                return record;
            },

            /**
             * Gets the position in the datasource of a record with the specified UID.
             * @param uid {Number}
             * @returns {Object} The index of the specified record. Returns -1 if not found.
             */
            getRowIndex: function (uid) {
                var me = this,
                    result = -1,
                    listSource = ko.valueOf(me.ListSource());

                $.each(listSource, function (index, item) {
                    if (ko.valueOf(item[me.Identifier]) == uid) {
                        result = index;
                        return false;
                    }
                });

                return result;
            },

            updateSelectedItem: function () {
                var me = this;
                var selectedItemId = me._SelectedItemId = me.SelectedItemId(),
                    selectedItem = me.findByUid(selectedItemId);
                if (!selectedItem) {
                    me.SelectedItemId(null);
                    me._SelectedItemId = null;
                }
                me.SelectedItem(selectedItem);
            },

            onPropertyChanging: function (propertyName) {
                if (propertyName === 'SelectedItem') {
                    this.propertiesBinding = true;
                }
            },

            onPropertyChanged: function (propertyName) {
                var me = this;

                switch (propertyName) {
                    case 'SelectedItemId':
                        me.updateSelectedItem();
                        break;
                    case 'SelectedItem':
                        var selectedItem = me.SelectedItem() || null;
                        me.propertiesBinding = false;
                        me.fireEvent('selectedItemChanged', {sender: me, record: selectedItem});
                        break;
                }
                me.parent(propertyName);
            },

            //region Grid events handlers

            _onCellBeginEdit: function (e) {
                var me = this;

                e = addSender(me, e);

                if (me.AllowEdit() === false) {
                    e.preventDefault();
                    return;
                }

                me.fireEvent('cellBeginEdit', e);
            },

            _onCellValueChanged: function (e) {
                var me = this;

                e = addSender(me, e);
                me.fireEvent('cellValueChanged', e);
            },

            //endregion

            enableEditing: function () {
                this.ReadOnly(false);
            },

            disableEditing: function () {
                this.ReadOnly(true);
            },

            /**
             * Creates a new record, based on information inferred from the fields configuration.
             * @returns {Object}
             * @protected
             */
            _createEmptyRecord: function () {
                var me = this,
                    rec = ts.createEntity();

                $.each(me.Fields(), function (key, field) {
                    var propertyName = ko.valueOf(field.PropertyName);
                    rec[propertyName] = ko.observable(null);
                    if (field.type == 'bool')
                        rec[propertyName](false);
                    // also add display property for lookup/browse fields
                    if (field.type == 'adaptiveLookup' || field.type == 'selection' || field.type == 'browse') {
                        rec[ko.valueOf(field.DisplayPropertyName)] = ko.observable(null);
                    }
                });

                return rec;
            },

            /**
             * <p>Creates a new records, adds it to the datasource and returns it.</p>
             * @return {Object} The added record.
             * @fires TS.viewModel.BindingList#beforeAdd
             * @fires TS.viewModel.BindingList#addNew
             * @fires TS.viewModel.BindingList#afterAdd
             */
            addRecord: function () {
                var me = this,
                    newRec,
                    listSource = me.ListSource(),
                    e;

                e = addSender(me, e);

                me.fireEvent('beforeAdd', e);
                if (e.isDefaultPrevented()) {
                    return null;
                }

                newRec = me._createEmptyRecord();

                me.fireEvent('addNew', {item: newRec, sender: me});
                if (this.addFirst === true) {
                    listSource.unshift(newRec);
                } else {
                    listSource.push(newRec);
                }
                me.fireEvent('afterAdd', {item: newRec, sender: me});

                me.fireEvent('dataChanged', {sender: me});
                me.SelectedItem(newRec);
                return newRec;
            },

            /**
             * <p>Deletes the currently selected record. If no record is selected, a notification is displayed.</p>
             * @fires TS.viewModel.BindingList#beforeDelete
             * @fires TS.viewModel.BindingList#afterDelete
             */
            deleteRecord: function () {
                var me = this;

                if (ko.valueOf(me.AllowDelete) === false) {
                    TS.trace('AllowDelete is false');
                    return;
                }

                var selectedItem = me.SelectedItem();

                if (!selectedItem || $.isEmptyObject(selectedItem)) {
                    TS.Notify.info(TS.cultures.current.list.NoRecordSelected);
                    return;
                }

                var e = {item: selectedItem, sender: me};

                me.fireEvent('beforeDelete', e);
                if (e.isDefaultPrevented()) {
                    return;
                }

                var selectedItemIndex = me.getRowIndex(selectedItem.UID());
                if (selectedItemIndex > -1) {
                    var domain = me.Domain(),
                        listSource = me.ListSource(),
                        listSourceValue = ko.valueOf(listSource);
                    domain.avoidResettingValueFromFilters = true;

                    listSource.splice(selectedItemIndex, 1); //remove from observable array
                    if (listSourceValue.length >= selectedItemIndex + 1) {
                        me.SelectedItem(listSourceValue[selectedItemIndex]);
                    } else if (!listSourceValue.length) {
                        me.SelectedItem(null);
                    } else {
                        me.SelectedItem(listSourceValue[selectedItemIndex]);
                    }

                    setTimeout(function () {
                        domain.avoidResettingValueFromFilters = false;
                    }, 0);
                }
                me.fireEvent('afterDelete', {item: selectedItem, sender: me});
            },

            //endregion

        });

    TS.ObjectFactory.map('BindingListProperty', TS.domain.properties.BindingListProperty);
})();